import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import {
  PATIENT_PORTAL_SYSTEM_UUIDS,
  PatientPortalSystemOptions,
} from 'types/patient-portal-system.types';

export const GET_APP_INIT_DETAILS_MESSAGE_TYPE = 'get_app_init_details';

export const getAppInitDetails = (
  systemId: PatientPortalSystemOptions,
  userId: string,
): Promise<{ eligible: boolean }> =>
  SocketAsFetch.fetch({
    message_type: GET_APP_INIT_DETAILS_MESSAGE_TYPE,
    info: {
      version: 2,
      ...(userId && { user_id: userId }),
    },
    custom_fields: {
      systemId: PATIENT_PORTAL_SYSTEM_UUIDS[systemId],
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any);
